// extracted by mini-css-extract-plugin
export default {"smBreak":"600px","root":"v7oBo_7Od1PK2gM_qouo","collapsed":"JUlNpAhQpy5i9SvYlAFY","paymentDue":"DVUDxv3smWnqlkjzgoFs","title":"xQY5IAKBB1GXwSQ_b1rQ","text":"FxEdCmYLCvayMEYF5svC"};